<template>
  <SearchResultsGrid
    :search-input="{ query: searchQuery }"
    :search-query="searchQuery"
  />
</template>

<script setup lang="ts">
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/zoekresultaten/[searchQuery]",
    fr: "/resultatdecherche/[searchQuery]",
    nl: "/zoekresultaten/[searchQuery]",
  },
});

useHead({
  meta: [
    { name: "robots", content: "noindex,follow" },
  ],
});

const route = useRoute();
const searchQuery = computed(() => route.params.searchQuery as string);
</script>

<style lang="scss" scoped>
.searchbar {
  z-index: 1;
}
</style>
